export const TRUSTPILOT_WIDGET_SCRIPT_TAG_SRC = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
